import { registerBlockType } from '@wordpress/blocks';
import { useBlockProps } from '@wordpress/block-editor';
import { TextControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

registerBlockType('puroclean/text-banner', {
    edit({ attributes, setAttributes }) {
        const { text, link } = attributes;
        
        const blockProps = useBlockProps({
            className: 'text-banner'
        });

        return (
            <div {...blockProps}>
                {/* Editor Controls */}
                <div className="mb-4 p-4 border border-gray-300 bg-gray-50 rounded">
                    <TextControl
                        label={__('Banner Text', 'puroclean')}
                        value={text}
                        onChange={(value) => setAttributes({ text: value })}
                        placeholder={__('Enter your banner text...', 'puroclean')}
                    />
                    <TextControl
                        label={__('Link', 'puroclean')}
                        value={link}
                        onChange={(value) => setAttributes({ link: value })}
                        placeholder={__('Enter your link...', 'puroclean')}
                    />
                </div>
                
                {/* Preview */}
                <div className="py-12 bg-red-700 text-white">
                    <div className="max-w-content mx-auto">
                        <div className="text-center">
                            <p className="text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-tight">
                                {text || __('Your banner text here', 'puroclean')}
                            </p>
                        </div>
                    </div>
                </div>
                
                {/* Color Bar */}
                <div className="flex w-full h-4">
                    <div className="flex-1 bg-secondary"></div>
                    <div className="flex-1 bg-primary"></div>
                    <div className="flex-1 bg-[#373536]"></div>
                    <div className="flex-1 bg-[#A7A9AC]"></div>
                </div>
            </div>
        );
    },
    save() {
        return null; // Server-side rendered
    }
}); 